import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MmuLogLevel } from './mmu-log-level.enum';


const MMU_LOG_LEVEL_COOKIE_NAME = 'log_level';

export const setupLogLevel = (): MmuLogLevel | undefined => {
  const cookieService: CookieService = inject(CookieService);
  const hasCookie = cookieService.check(MMU_LOG_LEVEL_COOKIE_NAME);

  if (!hasCookie) {
    return;
  }

  const logLevelCookie = cookieService.get(MMU_LOG_LEVEL_COOKIE_NAME);
  const logLevelAsNum = parseInt(logLevelCookie, 10);

  if (!isNaN(logLevelAsNum) && Object.values(MmuLogLevel).includes(logLevelAsNum)) {
    console.info(`[Logging]: Log level set via cookie to "${logLevelCookie}"`);
    return logLevelAsNum;
  }

  const logLevel: MmuLogLevel = MmuLogLevel[logLevelCookie.toUpperCase() as keyof typeof MmuLogLevel];

  if (logLevel) {
    console.info(`[Logging]: Log level set via cookie to "${logLevelCookie}"`);
    return logLevel;
  }

  // tslint:disable-next-line:no-console
  // Cannot use MmuLogger here, as it is not yet initialized and would cause a circular dependency
  console.warn(`[Logging]: Invalid log level in cookie ("${logLevelCookie}"). Please refer to the MmuLogLevel enum for valid values.`);
};
